import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import Help from '../../Common/Help/Help';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Marketing extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            banners: {
                halfBanner: '',
                fullBanner: ''
            },
            webaccess: '',
            AWSDomain: 'https://s3.amazonaws.com/prdv2-dt-static/',
            publicDomain: 'https://www.showtix4u.com/',
            current_client_id: 0,
            widgetCodeSnippet: '',
            videos: [],
        }
    }

    getCodeSnippet = () => {
        let html = strings.comment1 + '\n';
        html += '<div id="stx-container"></div>' + '\n';
        html += '<script src="' + process.env.REACT_APP_PUBLIC_URL_PRETTY + '/widget.js"></script>' + '\n';
        html += '<script>' + '\n';
        html += 'showtixWidget.loadEvents(' + this.state.current_client_id  + ');' + '\n';
        html += '</script>' + '\n';
        html += strings.comment2;
        return html;
    }

    copyHtmlToClipboard = (event) => {
        let inputId = event.target.id;
        let originalInput = document.getElementById(inputId);
        // Create a new textarea element and give it id='temp_element'
        let textarea = document.createElement('textarea');
        textarea.id = 'temp_element1';
        // Optional step to make less noise on the page, if any!
        textarea.style.height = 0;
        // Now append it to your page somewhere, I chose <body>
        document.body.appendChild(textarea);
        // Give our textarea a value of whatever inside the div of id=containerid
        textarea.value = originalInput.value;
        // Now copy whatever inside the textarea to clipboard
        let selector = document.querySelector('#temp_element1');
        selector.select();
        document.execCommand('copy');
        // Remove the textarea
        document.body.removeChild(textarea);
        setTimeout(function () { originalInput.select(); }, 50); //select all text in any field on focus for easy re-entry. Delay sightly to allow focus to "stick" before selecting.

        // focus & select text in the field
        document.getElementById(inputId).focus();
        document.getElementById(inputId).select();
    }

    componentWillReceiveProps(nextProps){
        const current_client_id = nextProps.client.id;
        const webaccess = `https://www.showtix4u.com/events/${nextProps.client.id}`;
        const banners = { ...this.state.banners };
        const root = process.env.REACT_APP_PUBLIC_URL;
        banners["halfBanner"] = `<a href="${webaccess}" target="_blank" rel="noopener"><img src="${root}/images/banners/halfBanner.jpg" /></a>`;
        banners["fullBanner"] = `<a href="${webaccess}" target="_blank" rel="noopener"><img src="${root}/images/banners/fullBanner.jpg" /></a>`;
        this.setState({ banners });
        this.setState({ webaccess });
        this.setState({ current_client_id },
            () => this.setState({
                widgetCodeSnippet: this.getCodeSnippet()
            })
        );
    }

    componentDidMount() {
        this.getAdminVideos();
    }

    getAdminVideos = () => {
        const getVideos = async () => {
            try {
                const videosResponse = await getVideosAPI();
                console.log('videosResponse: ', videosResponse);
                if (videosResponse.data) {
                    const videos = videosResponse.data;
                    this.setState({
                        videos,
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getVideosAPI() {
            return await ApiRequest('/admin/videos', {
                method: 'GET',
            });
        }
        getVideos();
    }

    render() {
        const videos = this.state.videos;
		let videoUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
        videos.forEach((video) => {
            if (video.title.includes('Client Prefs:Users')) {
                videoUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
			}
        });
        return ( 
            <div className="showtix-section showtix-background__primary-2">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-12">
                            <h1>{strings.marketing}</h1>
                            <div className="row">
                                <div className="col-12 col-lg-8">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="web-access">{strings.webAccess}
                                            <span id="tooltip-webAccess" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-webAccess">
                                                {strings.webAccessTooltip}
                                            </Tooltip>
                                        </label>

                                        <div className="showtix-form__input showtix-form__vanity">
                                            <div className="showtix-form__input prefix">
                                                <input className="showtix-input" type="text" readOnly="readonly" value='https://www.showtix4u.com/events/' />
                                            </div>
                                            <input className="showtix-input field"
                                                id="web-access"
                                                type="text"
                                                name="url_short_name"
                                                value={this.props.client.url_short_name}
                                                onChange={this.props.handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                { strings.helps &&
                                <div className="col-12 col-lg-4">
                                    <div className="showtix-box">
                                        <div className="showtix-padder">
                                            <h3 className="showtix-box__title">{strings.video.title}</h3>
                                            <p><a href={videoUrl} target="_blank" rel="noopener">{strings.video.content1}</a></p>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-12 col-md-12">
                            <div className="row">
                                <div className="col-12 col-lg-8">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="full-banner">{strings.embedWidgetTitle}
                                            <span id="tooltip-widget" className="showtix-tooltip">!</span>
                                            <Tooltip placement="top" target="tooltip-widget">
                                                {strings.embedWidgetTooltip}
                                                <img src={process.env.REACT_APP_PUBLIC_URL + "/images/embed-widget.png"} alt="widget"/>
                                            </Tooltip>
                                        </label>

                                        <div className="showtix-form__input">
                                            <textarea
                                                style={{ height: 160 }}
                                                id="embed-widget"
                                                className="showtix-input showtix-word-break"
                                                readOnly="true"
                                                rows="4"
                                                value={this.state.widgetCodeSnippet}
                                                onClick={this.copyHtmlToClipboard}
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                                { strings.helpWidget && strings.helps &&
                                <div className="col-12 col-lg-4">
                                    {strings.helpWidget.map((help, i) =>
                                        <Help help={help} key={i} />
                                    )}
                                    {strings.helps.map((help, i) =>
                                        <Help help={help} key={i} />
                                    )}
                                </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="half-banner">{strings.halfBanner}</label>

                                <div className="showtix-form__input">
                                    <textarea
                                        id="half-banner"
                                        className="showtix-input showtix-word-break"
                                        readOnly="true"
                                        rows="4"
                                        value={this.state.banners.halfBanner}
                                        onClick={this.copyHtmlToClipboard}
                                    >
                                    </textarea>
                                    <img className="showtix-responsive" src={process.env.REACT_APP_PUBLIC_URL + "/images/banners/halfBanner.jpg"} alt="half-banner" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="full-banner">{strings.fullBanner}</label>

                                <div className="showtix-form__input">
                                    <textarea
                                        id="full-banner"
                                        className="showtix-input showtix-word-break"
                                        readOnly="true"
                                        rows="4"
                                        value={this.state.banners.fullBanner}
                                        onClick={this.copyHtmlToClipboard}
                                    >
                                    </textarea>
                                    <img className="showtix-responsive" src={process.env.REACT_APP_PUBLIC_URL + "/images/banners/fullBanner.jpg"} alt="full-banner"/>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}
 
export default Marketing;



// WEBPACK FOOTER //
// ./src/components/ClientPreferences/Marketing/Marketing.js